import React from "react";
import { Box, Typography, TextField, IconButton, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Field from "../shared/Field";

const FormFooter = ({ data, onChange }) => {
  const updateLink = (i, field, value) => {
    const usefulLinks = [...data.usefulLinks];
    usefulLinks[i] = { ...usefulLinks[i], [field]: value };
    onChange({ ...data, usefulLinks });
  };

  const addLink = () =>
    onChange({
      ...data,
      usefulLinks: [...data.usefulLinks, { label: "", url: "" }],
    });

  const removeLink = (i) => {
    if (data.usefulLinks.length <= 1) return;
    onChange({
      ...data,
      usefulLinks: data.usefulLinks.filter((_, idx) => idx !== i),
    });
  };

  return (
    <Box>
      <Field
        label="Footer Description"
        value={data.description}
        onChange={(v) => onChange({ ...data, description: v })}
        multiline
        placeholder="A specialized MERN stack agency..."
      />
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <Field
          label="Contact Email"
          value={data.contactEmail}
          onChange={(v) => onChange({ ...data, contactEmail: v })}
          placeholder="admin@softheight.com"
        />
        <Field
          label="Contact Phone"
          value={data.contactPhone}
          onChange={(v) => onChange({ ...data, contactPhone: v })}
          placeholder="+923074533954"
        />
      </Box>
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        display="block"
        mb={1.5}
        mt={1}
      >
        Useful Links
      </Typography>
      {data.usefulLinks.map((link, i) => (
        <Box key={i} display="flex" gap={1} mb={1} alignItems="center">
          <TextField
            size="small"
            label="Label"
            value={link.label}
            onChange={(e) => updateLink(i, "label", e.target.value)}
            placeholder="Home"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
          <TextField
            size="small"
            label="URL"
            value={link.url}
            onChange={(e) => updateLink(i, "url", e.target.value)}
            placeholder="/home"
            sx={{
              flex: 2,
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
          <IconButton size="small" color="error" onClick={() => removeLink(i)}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={addLink}
        sx={{ textTransform: "none", color: "text.secondary", mt: 0.5 }}
      >
        Add Link
      </Button>
    </Box>
  );
};

export default FormFooter;
